import { Observable } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { Store } from '@ngrx/store'

import { authSelectors } from '../auth/auth.selectors'
import { AppState } from '../core.state'

import { inject } from '@angular/core'
import { environment } from 'src/environments/environment'

export function TokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const store = inject(Store<AppState>)

  return store.select(authSelectors.selectToken).pipe(
    take(1),
    switchMap((token) => {
      if (token && req.url.includes(environment.backendApiUrl)) {
        const clonedReq = req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token
          }
        })

        return next(clonedReq)
      }

      return next(req)
    })
  )
}
